<div class="consult-table-section">
  <p class="consult-table-summary" aria-live="polite">{{ creditsFoundLabel }}</p>

  <div class="consult-table-shell">
    <ng-container *ngIf="itens.length > 0; else emptyTableState">
      <b3-table
        size="sm"
        background="striped"
        aria-label="Lista de registros de crédito de carbono"
        [attr.aria-rowcount]="totalItens"
        aria-colcount="8">
        <b3-table-rowgroup group="header">
          <b3-table-row>
            <b3-table-cell-header label="Data de Registro"></b3-table-cell-header>
            <b3-table-cell-header label="Código IF"></b3-table-cell-header>
            <b3-table-cell-header label="ID do Projeto"></b3-table-cell-header>
            <b3-table-cell-header label="Serial Range"></b3-table-cell-header>
            <b3-table-cell-header label="Conta do Registrador"></b3-table-cell-header>
            <b3-table-cell-header label="Conta Detentor"></b3-table-cell-header>
            <b3-table-cell-header label="Status do Registro"></b3-table-cell-header>
            <b3-table-cell-header label="Detalhes" align="center"></b3-table-cell-header>
          </b3-table-row>
        </b3-table-rowgroup>

        <b3-table-rowgroup group="body">
          <b3-table-row
            *ngFor="let credit of itens; trackBy: trackByCarbonCreditCode"
            [id]="'credit-consult-row-' + credit.carbonCreditCode">
            <b3-table-cell variant="text" [label]="credit.insertDate || '-'"></b3-table-cell>
            <b3-table-cell variant="text" [label]="credit.carbonCreditCode || '-'"></b3-table-cell>
            <b3-table-cell variant="text" [label]="credit.projectId || '-'"></b3-table-cell>
            <b3-table-cell variant="text" [label]="credit.serialCode || '-'"></b3-table-cell>
            <b3-table-cell variant="text" [label]="credit.registerCode || '-'"></b3-table-cell>
            <b3-table-cell variant="text" [label]="credit.holderCode || '-'"></b3-table-cell>
            <b3-table-cell variant="tag">
              @let statusBadge = getStatusBadge(credit);
              <b3-tag
                size="sm"
                variant="filled"
                [icon]="statusBadge.icon"
                [tone]="statusBadge.tone"
                [label]="statusBadge.label">
              </b3-tag>
            </b3-table-cell>
            <b3-table-cell variant="slot">
              <div class="consult-table-actions">
                <b3-tooltip label="Detalhes" variant="single-line" pointer="bottom">
                  <b3-button
                    type="button"
                    variant="ghost"
                    tone="default"
                    size="sm"
                    [attr.aria-label]="getDetailsLabel(credit)"
                    (b3-click)="openDetail(credit)">
                    <b3-icon name="visibility"></b3-icon>
                  </b3-button>
                </b3-tooltip>
              </div>
            </b3-table-cell>
          </b3-table-row>
        </b3-table-rowgroup>
      </b3-table>
    </ng-container>

    <ng-template #emptyTableState>
      <app-consult-table-empty-state></app-consult-table-empty-state>
    </ng-template>
  </div>

  <div class="consult-table-pagination" *ngIf="totalItens > 0">
    <p class="consult-table-pagination__info">{{ recordsPerPageLabel }}</p>
    <b3-pagination
      *ngIf="totalPages > 1"
      aria-label="Paginação da consulta de créditos"
      variant="numbers"
      navigation="icon"
      overflow
      [attr.total]="totalPages"
      [attr.current]="pagination.page ?? 1"
      (b3-change)="onPaginationChange($event)">
    </b3-pagination>
  </div>
</div>
